<div class="page">
	<div class="page__wrapper wrapper">
		<app-back-button [page]="'report'"></app-back-button>
	</div>

	<div class="page__body">
		<div class="page__wrapper wrapper">
			<div class="report-export">
				<div class="report-export__title">{{ selectedOption.name }}</div>
				<div class="spacer"></div>

				<form class="report-export__form" [formGroup]="form" (ngSubmit)="handleDownloadCsv()">
					<div class="report-export__form__filter" *ngIf="filterCardAndRest">
						<label *ngFor="let item of tabRestAndCard" class="report-export__form__filter__label">
							<input
								ngModel
								type="radio"
								[id]="item.id"
								[value]="item.id"
								class="report-export__form__filter__input"
								name="venue"
							/>
							<div class="report-export__form__filter__box w151">
								<p class="report-export__form__filter__text">{{ item.title }}</p>
							</div>
						</label>
					</div>

					<ng-container *ngIf="datePeriod">
						<div class="field__label">
							<span>Período Inicial</span>
							<mat-form-field class="example-full-width" appearance="fill">
								<input
									matInput
									[matDatepicker]="startPicker"
									formControlName="startDate"
									(click)="startPicker.open()"
								/>
								<mat-datepicker-toggle
									matIconPrefix
									[for]="startPicker"
								></mat-datepicker-toggle>
								<mat-datepicker touchUi #startPicker></mat-datepicker>
							</mat-form-field>
						</div>
						<span class="field__feedback"></span>

						<div class="field__label">
							<span>Período Final</span>
							<mat-form-field class="example-full-width" appearance="fill">
								<input
									matInput
									[matDatepicker]="endPicker"
									formControlName="endDate"
									(click)="endPicker.open()"
								/>
								<mat-datepicker-toggle
									matIconPrefix
									[for]="endPicker"
								></mat-datepicker-toggle>
								<mat-datepicker touchUi #endPicker></mat-datepicker>
							</mat-form-field>
						</div>
						<span class="field__feedback"></span>

						<div class="report-export__form__buttons">
							<button
								*ngIf="selectedOption.slug === 'financial-amenities'"
								class="report-export__form__button button"
								type="button"
								(click)="handlePreviewJson()"
								[disabled]="status === 'pending'"
								[ngClass]="{ disabled: status === 'pending' }"
							>
								Pré-visualizar relatório
							</button>

							<button
								class="report-export__form__button button"
								type="submit"
								[disabled]="status === 'pending'"
								[ngClass]="{ disabled: status === 'pending' }"
							>
								Download relatório
							</button>
						</div>
					</ng-container>
				</form>
			</div>

			<div class="boxTableReport">
				<div
					class="boxTableReport__alert"
					*ngIf="selectedOption.slug === 'nota-fiscal-venue' && reportWithoutGroup?.length"
				>
					<h1 class="boxTableReport__alert__title">Venues sem configuração de grupo/envio</h1>
					<app-general-table [info]="reportWithoutGroup"></app-general-table>
				</div>

				<app-general-table
					[info]="reportFiltered"
					*ngIf="selectedOption.slug === 'financial-amenities'"
				></app-general-table>
			</div>
		</div>
	</div>
</div>
